//@flow
import * as React from 'react';
import { FormGroup } from 'reactstrap';
import FormInput from './../../../components/inputs/FormInput';

type Props = { onChangeText: any, entity: any, onChangeValue: any };

export default class IntegracaoConnectListFilter extends React.PureComponent<Props> {
  render() {
    const { entity } = this.props;
    return (
      <React.Fragment>
        <FormGroup className="col-12 col-xl-3">
          <FormInput
            label="Nome do estabelecimento"
            placeholder={'Nome'}
            id={'namefilter'}
            name="nome"
            onChange={this.props.onChangeDate}
            type={'text'}
            size={12}
            style={'col-12 col-sm-4 offset-sm-1'}
            value={entity.nome}
          />
        </FormGroup>
        <FormGroup className="col-12 col-xl-3">
          <FormInput
            label="E-mail"
            placeholder={'E-mail'}
            id={'email'}
            name="email"
            onChange={this.props.onChangeDate}
            type={'text'}
            size={12}
            style={'col-12 col-sm-4'}
            value={entity.email}
          />
        </FormGroup>
      </React.Fragment>
    );
  }
}
